import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHotDrinkCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHotDrinkCup"><Path d="M20.5 5.5H3.5V8.5H20.5V5.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M5 5.32432L6 2.5H18L19 5.32432" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 8.75L6 21.5H18L19.5 8.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHotDrinkCup;
